import { minutesToMilliseconds } from 'date-fns';

import { placeClient } from '@portal-clients/place';

import { useClientQuery } from '@frontend/hooks';
import { useOptionalUser } from '@frontend/utils';

export interface UsePlacesProps {
  shopId: string;
  enabled?: boolean;
  onError?(error: Error): void;
}

export const getPlacesQueryKey = (
  shopId: string,
  userLocale: string | undefined,
) => ['places', shopId, userLocale ?? 'no-locale'];

export const makePlacesQueryOptions = (
  shopId: string,
  userLocale: string | undefined,
) => ({
  queryKey: getPlacesQueryKey(shopId, userLocale),
  queryFn: () => placeClient.get(shopId),
  staleTime: minutesToMilliseconds(5),
});

export const usePlacesQuery = ({
  shopId,
  enabled,
  onError,
}: UsePlacesProps) => {
  const { user } = useOptionalUser();
  const { queryKey, queryFn, staleTime } = makePlacesQueryOptions(
    shopId,
    user?.locale,
  );

  return useClientQuery({
    queryKey,
    onFetch: queryFn,
    onError,
    enabled,
    staleTime,
  });
};
